














































































































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { CommonFormService } from "../../service/common-form.service";
import { CommonForm, CommonFormFollowup211 } from "../../models/common-form";
//import { numeric } from "vuelidate/lib/validators";
import { ContentService } from "@/service/content.service";
import { Followup211Content } from "@/models/content/followup-211";
import CommonMixin from "@/mixins/common-mixins";
import moment from 'moment'
import { ProviderNotificationData } from "@/models/notification-data";

@Component({
  components: {},
})
export default class Followup211 extends Mixins(CommonMixin) {
  commonFormService = new CommonFormService();
  contentService = new ContentService();
  content: Followup211Content = {} as Followup211Content;
  pageData = {} as CommonFormFollowup211;
  commonForm = {} as CommonForm;
  notificationData: Array<ProviderNotificationData> = [];
  pageDataLoaded = false;
  haveBadToken = false;
  hideForNewFollowupEligibility = true;

  async mounted(): Promise<void> {
    try {
      this.content = await this.contentService.getFollowup211Content();
      const token = this.$route.params.token;
      this.pageData = await this.commonFormService.getFeedbackFollowup(token);
      if ( this.pageData.commonForm) {
        this.commonForm = this.pageData.commonForm
      }

      if ( this.pageData.notificationData) {
        this.notificationData = this.pageData.notificationData
      }
      this.pageDataLoaded = true;
    } catch (error) {
      if (error.response.status === 422) {
        this.haveBadToken = true;
      }
    }
  }


  get languages(): string {
    const languages = [];
    if (this.commonForm.caregiver.speakenglish === true) {
      languages.push("English");
    }
    if (this.commonForm.caregiver.speakspanish === true) {
      languages.push("Spanish");
    }
    if (this.commonForm.caregiver.speakarabic === true) {
      languages.push("Arabic");
    }
    if (this.commonForm.caregiver.speakother === true) {
      languages.push(this.commonForm.caregiver.otherlanguage);
    }
    return languages.join(", ");
  }

  get formCompletedLanguage(): string {
    if (this.commonForm.language === "es") {
      return "Spanish";
    } else if (this.commonForm.language === "ar") {
      return "Arabic";
    } else {
      return "English";
    }
  }

   get formSubmittedDate(): string {
    if ( this.commonForm.modifieddate != null) {
        return  moment(this.commonForm.modifieddate).format('MM/DD/YYYY');
    }
    return ''
  }
}


